// @ts-check
// ====== S2 partial: estrazione event-handlers Sicurezza ======
// Listener bus + scorciatoie. Logica utenti/backup resta in sicurezza.js/backups.js.
//
// Emette 'security:user-changed' dopo upsert/delete, così altri moduli (es.
// dashboard) possono reagire senza chiamare renderSicurezza direttamente.

function wireSecurityBusListeners() {
  // @ts-ignore — bus globale
  if (!globalThis.bus) return;
  // @ts-ignore
  globalThis.bus.on('security:user-changed', () => {
    // @ts-ignore
    if (typeof renderSicurezza === 'function') renderSicurezza();
  });
  // @ts-ignore
  globalThis.bus.on('backup:created', () => {
    // @ts-ignore
    if (typeof renderBackups === 'function') renderBackups();
  });
  // @ts-ignore
  globalThis.bus.on('backup:restored', () => {
    // @ts-ignore
    if (typeof renderAll === 'function') renderAll();
  });
}

document.addEventListener('DOMContentLoaded', wireSecurityBusListeners);
wireSecurityBusListeners();

export {};
